import { faXmark } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, JoonUIColor, Typography } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"
import { create } from "zustand"

import { useReferralModalStore } from "./ReferralModal"
import useMobile from "../../../hooks/useMobile"
import { localStorageItems } from "../../../util/storage"

interface ReferralGiftCardStoreProps {
  showTooltip: boolean
  setShowTooltip: (showTooltip: boolean) => void
}

export const useReferralGiftCardStore = create<ReferralGiftCardStoreProps>(
  (set) => ({
    showTooltip: false,
    setShowTooltip: (showTooltip) => set({ showTooltip }),
  })
)

const ReferralGiftCardSection = () => {
  const { showTooltip, setShowTooltip } = useReferralGiftCardStore()
  const { onOpen: onOpenReferralModal } = useReferralModalStore()
  const isMobile = useMobile()
  const { t } = useTranslation()

  const showReferralGiftCardSection =
    localStorage.getItem(localStorageItems.hasSeenReferralFTUXModal) &&
    !localStorage.getItem(
      localStorageItems.hasDismissedReferralGiftCardSection
    ) &&
    !showTooltip

  if (!showReferralGiftCardSection) return null

  return (
    <div
      className={`w-full flex flex-col  items-center border border-borderPrimary rounded-md ${
        showTooltip ? "hidden" : ""
      }`}
    >
      <div className="w-full flex flex-row gap-2 justify-between items-center h-[51px] px-4 relative">
        <img
          src="/images/background/referral-gift-card-banner-bg.png"
          alt="Banner"
          className="w-full h-[51px] absolute top-0 left-0 rounded-t-md"
        />
        <Typography
          variant={isMobile ? "bodyBold" : "h3"}
          className="z-10 whitespace-nowrap text-ellipsis overflow-hidden"
        >
          {t("REFERRAL_GIFTCARD_TITLE")}
        </Typography>
        <button
          onClick={() => {
            localStorage.setItem(
              localStorageItems.hasDismissedReferralGiftCardSection,
              "true"
            )
            setShowTooltip(true)
          }}
          className="z-10! flex items-center justify-center"
        >
          <FontAwesomeIcon
            icon={faXmark}
            color={JoonUIColor.icon.neutral}
            fontSize={20}
          />
        </button>
      </div>
      <div className="w-full flex flex-col gap-3 justify-between items-center p-4 bg-backgroundPrimary">
        <Typography variant="bodySmall">
          {t("REFERRAL_GIFTCARD_DESC")}
        </Typography>
        <Button
          text={t("REFERRAL_MODAL_SHARE")}
          onClick={() => onOpenReferralModal("me_tab_card")}
          fullWidth
        />
      </div>
    </div>
  )
}

export default ReferralGiftCardSection
